import { render, staticRenderFns } from "./JoiningModal.vue?vue&type=template&id=f2d8e8ca"
import script from "./JoiningModal.vue?vue&type=script&lang=js"
export * from "./JoiningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports